export default __webpack_public_path__ + "static/media/Tynker.ca70fb44.webp";